import {
  LISTING_PRICE_OPTIONS,
  LISTING_PRICE_SETTINGS_PATH,
  SHOW_ON_LISTING_LABEL,
  type ListingPriceSettings,
} from '@auctisync/api-client';
import { Link } from 'react-router-dom';

/**
 * A lot's "Show on listing" boxes — which prices bidders see on this lot
 * (Jim, 2026-10-06). The three choices and their words come from the shared
 * `LISTING_PRICE_OPTIONS`, so this row, the "Prices to review" column and the
 * Cataloging app offer the same ones.
 *
 * A tick saves at once (`onChange`): no separate Save to forget, and the
 * page's form never carries the boxes, so its own Save cannot undo one.
 */
export function ListingPriceChoices({
  value,
  onChange,
  disabled,
}: {
  value: ListingPriceSettings;
  onChange: (patch: Partial<ListingPriceSettings>) => void;
  disabled?: boolean;
}) {
  return (
    <div style={{ display: 'grid', gap: '0.35rem' }} data-testid="listing-price-choices">
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          alignItems: 'center',
          gap: '0.5rem 1rem',
          fontSize: '0.9rem',
        }}
      >
        <span style={{ fontWeight: 500 }}>{SHOW_ON_LISTING_LABEL}:</span>
        {LISTING_PRICE_OPTIONS.map((o) => (
          <label
            key={o.key}
            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.35rem' }}
          >
            <input
              type="checkbox"
              data-testid={`lot-show-${o.key}`}
              checked={value[o.key]}
              disabled={disabled}
              onChange={(e) => {
                onChange({ [o.key]: e.target.checked });
              }}
            />
            {o.label}
          </label>
        ))}
      </div>
      <ListingDefaultsLink />
    </div>
  );
}

/** Jim: "there should be a link to the setting in the 'Prices to review' section". */
export function ListingDefaultsLink() {
  return (
    <Link
      to={LISTING_PRICE_SETTINGS_PATH}
      data-testid="listing-defaults-link"
      style={{ fontSize: '0.85rem', color: 'var(--brand-primary-text, var(--brand-primary))' }}
    >
      Change which prices show by default →
    </Link>
  );
}
